import React from 'react';
import { Flex, useColorModeValue, Text } from '@chakra-ui/react';

type InboxPageWrapperProps = {
  children: React.ReactNode;
  pageTitle: string;
  pageSubtitle?: string;
  extraButtons?: React.ReactNode;
};

export const InboxPageWrapper: React.FC<InboxPageWrapperProps> = ({
  children,
  pageTitle,
  pageSubtitle,
  extraButtons,
}) => {
  const bg = useColorModeValue(
    'background.light.highest',
    'background.dark.lowest',
  );
  const pageTitleColor = useColorModeValue(
    'text.light.pageTitle',
    'text.dark.pageTitle',
  );
  const pageSubtitleColor = useColorModeValue(
    'text.light.secondary',
    'text.dark.secondary',
  );

  return (
    <Flex w="100%" direction="column" background={bg} p={10}>
      <Flex direction="column" gap={4} flex={{ base: 1, lg: 'none' }} mb={6}>
        <Flex
          direction="row"
          justifyContent="space-between"
          alignItems="center">
          <Text
            fontSize={32}
            fontFamily="marketingPage"
            fontWeight="bold"
            color={pageTitleColor}>
            {pageTitle}
          </Text>
          {extraButtons}
        </Flex>
        {pageSubtitle && (
          <Text
            fontSize={16}
            color={pageSubtitleColor}
            fontFamily="marketingPage">
            {pageSubtitle}
          </Text>
        )}
      </Flex>
      {children}
    </Flex>
  );
};
